import EventEmitter from 'events'
import { BYTE_UNITS } from '@/lib/constants'
import store from '@/store'

export default class VirtualInputFile extends EventEmitter {
  constructor({
    accept = '*',
    limit = true,
    multiple = false
  } = {}) {
    super()
    const virtualInput = document.createElement('input')

    // MB
    const fileSizeLimit = store.getters['auth/currentLicensedPlan'].maxFileSize * BYTE_UNITS.mb
    virtualInput.type = 'file'
    virtualInput.multiple = multiple
    virtualInput.accept = accept
    virtualInput.style = 'display: none;'
    document.body.appendChild(virtualInput)

    const removeVirtualInput = () => {
      document.body.removeChild(virtualInput)
      window.removeEventListener('focus', removeVirtualInput)
    }

    window.addEventListener('focus', removeVirtualInput)

    virtualInput.click()

    virtualInput.onchange = () => {
      for (const file of virtualInput.files) {
        if (limit && file.size > fileSizeLimit) {
          this.emit('fileSizeLimitError', file.name)
        } else {
          const reader = new FileReader()
          reader.onload = () => {
            this.emit('fileRead', {
              name: file.name,
              type: file.type,
              base64Data: reader.result
            })
          }
          reader.readAsDataURL(file)
        }
      }
    }
  }
}
